<template>
  <div class="column is-10">
    <form method="post" @submit.prevent="submitData()">
      <div class="field">
        <label class="label">Old Password</label>
        <div class="control">
          <input type="password" :class="{'input': true, 'is-danger': errors.has('oldpassword')}" v-model="oldpassword">
        </div>
        <p class="help is-danger" v-show="errors.has('oldpassword')" v-text="errors.first('oldpassword')"></p>
      </div>
      <div class="field">
        <label class="label">Password</label>
        <div class="control">
          <input type="password" :class="{'input': true, 'is-danger': errors.has('password')}" v-model="password">
        </div>
        <p class="help is-danger" v-show="errors.has('password')" v-text="errors.first('password')"></p>
      </div>
      <div class="field">
        <label class="label">Password Confirmation</label>
        <div class="control">
          <input type="password" :class="{'input': true, 'is-danger': errors.has('confpassword')}" v-model="confpassword">
        </div>
        <p class="help is-danger" v-show="errors.has('confpassword')" v-text="errors.first('confpassword')"></p>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link">Change Password</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      oldpassword: '',
      password: '',
      confpassword: ''
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
  },
  methods: {
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('profile/change_password', {
        oldpassword: this.oldpassword,
        password: this.password,
        confpassword: this.confpassword
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          alert('Change Password Success!')
          self.$geb.emit({id: 'profile_section_event', eventData: 'profile'})
          self.errors.clear()
          self.oldpassword = ''
          self.password = ''
          self.confpassword = ''
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.remove(name)
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/profile/components/ProfileChangePassword.vue